import {
  dvfvPersistencePlugin,
  PERSISTENCE_ERROR_CODE_PERMISSION_DENIED,
  PersistenceError,
} from '@sortera/dvfv-persistence'
// eslint-disable-next-line no-restricted-imports
import type { Firestore } from 'firebase/firestore'

import { trackError } from '@/services/analytics.ts'
import { t } from '@/services/translation/index.ts'

export function usePluginPersistence(firestore: Firestore): void {
  dvfvPersistencePlugin({
    firestore,

    onError(err, ctx) {
      const isPermissionError = err instanceof PersistenceError && err.code === PERSISTENCE_ERROR_CODE_PERMISSION_DENIED
      if (ctx.methodType === 'write') {
        const properties = { MethodName: ctx.methodName, Arguments: ctx.args }
        trackError(err, properties)

        // Handle error when trying to write without permission.
        // Note: For read, we do expect this error to happen for the user repository,
        // if a user has no user document (common for drivers).
        // Since the Firebase rules for that collection read from the same collection,
        // it can lead to a permission denied error. We do not want to alert the user in that case.
        if (isPermissionError) {
          const msg = t('error.permission-denied')
          // Todo: Show proper notification once we have support for that.
          alert(msg)
        }
      }
    },
  })
}
